
export const ollamaMcpTranslate = async (url, token, prompt) => {
    try {
      const result = await fetch(url + `/ollama-mcp/translate`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          prompt: prompt,
        }),
      })

      if (!result.ok) {
        throw new Error('error occured');
      }

      const resData = await result.json();
      console.log('translate', resData);

      return resData;

    } catch(err) {
      console.log('translate', err);
      throw err;
    }
  };